/** Pastell-Hintergrund + dunklere Schrift (wie Mitarbeiter-Avatare in EmployeesPage). */
type AvatarPair = { bg: string; text: string };

const DEFAULT: AvatarPair = { bg: 'bg-app-surface-muted', text: 'text-app-text-muted' };

const ORG_BY_TYPE: Record<string, AvatarPair> = {
  'Gewerblicher Kunde': { bg: 'bg-blue-100 dark:bg-blue-950/50', text: 'text-blue-700 dark:text-blue-200' },
  Lieferant: { bg: 'bg-amber-100 dark:bg-amber-950/50', text: 'text-amber-700 dark:text-amber-200' },
  Partner: { bg: 'bg-violet-100 dark:bg-violet-950/50', text: 'text-violet-700 dark:text-violet-200' },
};

const CONTACT_BY_KIND: Record<string, AvatarPair> = {
  Privatkunde: { bg: 'bg-emerald-100 dark:bg-emerald-950/50', text: 'text-emerald-700 dark:text-emerald-200' },
  'Gewerblicher Kontakt': { bg: 'bg-blue-100 dark:bg-blue-950/50', text: 'text-blue-700 dark:text-blue-200' },
};

export function organizationAvatarPair(organizationType: string | null | undefined): AvatarPair {
  const t = (organizationType ?? '').trim();
  return ORG_BY_TYPE[t] ?? DEFAULT;
}

export function contactAvatarPair(contactKind: string | null | undefined): AvatarPair {
  const k = (contactKind ?? '').trim();
  return CONTACT_BY_KIND[k] ?? DEFAULT;
}

/** Eine `className`-Zeile für Hintergrund + Initialenfarbe. */
export function organizationAvatarClassName(organizationType: string | null | undefined): string {
  const { bg, text } = organizationAvatarPair(organizationType);
  return `${bg} ${text}`;
}

export function contactAvatarClassName(contactKind: string | null | undefined): string {
  const { bg, text } = contactAvatarPair(contactKind);
  return `${bg} ${text}`;
}
